const stringifyErrorValue = value => {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }

  if (typeof value === "object") {
    for (const key of ["message", "reason", "error", "detail"]) {
      const nestedValue = stringifyErrorValue(value[key]);
      if (nestedValue) {
        return nestedValue;
      }
    }

    try {
      return JSON.stringify(value);
    } catch (e) {
      return "An unexpected error occurred.";
    }
  }

  return String(value);
};

export const getErrorMessage = error => {
  const responseData = error && error.response && error.response.data;
  return (
    stringifyErrorValue(responseData && responseData.message) ||
    stringifyErrorValue(responseData) ||
    stringifyErrorValue(error && error.message) ||
    "An unexpected error occurred."
  );
};
